import { ColumnDefinitions } from '../column-configs';

export const chatBotHiddenColumns = [
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.VisitorLastName,
  ColumnDefinitions.EmailAddress,
  ColumnDefinitions.VisitorPhone,
  ColumnDefinitions.VisitInfo,
  ColumnDefinitions.VisitRef,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.Experiments,
  ColumnDefinitions.ChatID
];

export const chatQueueHiddenColumns = [
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.InitialQuestion,
  ColumnDefinitions.VisitorLastName,
  ColumnDefinitions.EmailAddress,
  ColumnDefinitions.VisitorPhone,
  ColumnDefinitions.VisitInfo,
  ColumnDefinitions.VisitRef,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.Priority,
  ColumnDefinitions.Experiments,
  ColumnDefinitions.ChatID
];

export const chatAssignedHiddenColumns = [
  ColumnDefinitions.Answered,
  ColumnDefinitions.VisitorLastName,
  ColumnDefinitions.VisitorPhone,
  ColumnDefinitions.VisitInfo,
  ColumnDefinitions.VisitRef,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.Priority,
  ColumnDefinitions.Experiments,
  ColumnDefinitions.ChatID
];

export const chatClosedHiddenColumns = [
  ColumnDefinitions.Created,
  ColumnDefinitions.Answered,
  ColumnDefinitions.Ended,
  ColumnDefinitions.WindowClosed,
  ColumnDefinitions.Updated,
  ColumnDefinitions.VisitorLastName,
  ColumnDefinitions.VisitorPhone,
  ColumnDefinitions.VisitInfo,
  ColumnDefinitions.VisitRef,
  ColumnDefinitions.LanguageCode,
  ColumnDefinitions.WebsiteName,
  ColumnDefinitions.SurveyNPS,
  ColumnDefinitions.ChatID,
  ColumnDefinitions.VisitorID
];

export const emailQueuedHiddenColumns = [
  ColumnDefinitions.QueueTime,
  ColumnDefinitions.FirstIncomingArrived,
  ColumnDefinitions.EmailThreadType,
  ColumnDefinitions.EmailAccountName,
  ColumnDefinitions.AppliedRuleName,
  ColumnDefinitions.LastAssignedByOperatorName,
  ColumnDefinitions.TotalReassignCount,
  ColumnDefinitions.DestinationEmailAddress,
  ColumnDefinitions.EmailThreadID

];

export const emailAssignedHiddenColumns = [
  ColumnDefinitions.QueueTime,
  ColumnDefinitions.FirstIncomingArrived,
  ColumnDefinitions.Accepted,
  ColumnDefinitions.Opened,
  ColumnDefinitions.LastAssignedAnswered,
  ColumnDefinitions.EmailThreadType,
  ColumnDefinitions.EmailAccountName,
  ColumnDefinitions.AppliedRuleName,
  ColumnDefinitions.AnsweredByOperatorName,
  ColumnDefinitions.LastAssignedByOperatorName,
  ColumnDefinitions.TotalReassignCount,
  ColumnDefinitions.DestinationEmailAddress,
  ColumnDefinitions.EmailThreadID
];

export const emailClosedHiddenColumns = [
  ColumnDefinitions.QueueTime,
  ColumnDefinitions.FirstIncomingArrived,
  ColumnDefinitions.Accepted,
  ColumnDefinitions.Opened,
  ColumnDefinitions.Updated,
  ColumnDefinitions.LastIncomingArrived,
  ColumnDefinitions.LastAssignedAnswered,
  ColumnDefinitions.EmailThreadType,
  ColumnDefinitions.EmailAccountName,
  ColumnDefinitions.AppliedRuleName,
  ColumnDefinitions.AnsweredByOperatorName,
  ColumnDefinitions.LastAssignedByOperatorName,
  ColumnDefinitions.TotalReassignCount,
  ColumnDefinitions.DestinationEmailAddress,
  ColumnDefinitions.ClosedByOperatorName,
  ColumnDefinitions.EmailThreadID
];

export const messagingQueueHiddenColumns = [
  ColumnDefinitions.AgentMessageCount,
  ColumnDefinitions.VisitorMessageCount,
  ColumnDefinitions.InitialQuestion,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.LanguageCode,
  ColumnDefinitions.TextChatID
];

export const messagingAssignedHiddenColumns = [
  ColumnDefinitions.Answered,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.LanguageCode,
  ColumnDefinitions.TextChatID
];

export const messagingClosedHiddenColumns = [
  ColumnDefinitions.LanguageCode,
  ColumnDefinitions.TextChatID
];

export const messagingBotHiddenColumns = [
  ColumnDefinitions.Answered,
  ColumnDefinitions.TotalResponseTime,
  ColumnDefinitions.LanguageCode,
  ColumnDefinitions.TextChatID
];
